module.exports = __webpack_public_path__ + "static/media/checked-exam.d135ca1f.svg";